const actionTypeIdentifier = '88003816-9783-4839-8E3D-B6A5058F3443'

export const getActiveVendors = `GET-ACTIVE-VENDORS-${actionTypeIdentifier}`;
export const setBillingAccountError = `SET-BILLING-ACCOUNT-ERROR-${actionTypeIdentifier}`;
export const getAccountType = `GET-ACCOUNT-TYPE-${actionTypeIdentifier}`;
export const getAccountStatus = `GET-ACCOUNT-STATUS-${actionTypeIdentifier}`;
export const getAccountFirstBill = `GET-ACCOUNT-FIRST-BILL-${actionTypeIdentifier}`;
export const getAllocationLevel = `GET-ALLOCATION-LEVEL-${actionTypeIdentifier}`;
export const getAccountInterval = `GET-ALLOCATION-INTERVAL-${actionTypeIdentifier}`;
export const setDataByVendor = `SET-DATA-BY-VENDOR-${actionTypeIdentifier}`;
export const getAllAddressLocation1 = `GET-ALL-ADDRESS-LOCATION1-${actionTypeIdentifier}`;
export const getAllAddressLocation2 = `GET-ALL-ADDRESS-LOCATION2-${actionTypeIdentifier}`;
export const getAccountPurchaseOrder = `GET-ACCOUNT-PURCHASE-ORDER-${actionTypeIdentifier}`;
export const setDefaultState = `SET-DEFAULT-STATE-${actionTypeIdentifier}`;
export const fetchBillingAccountDetails = `FETCH-BILLING-ACCOUNT-DETAILS-${actionTypeIdentifier}`;
export const setLocationLoading = `SET-LOCATION-LOADING-${actionTypeIdentifier}`;
export const getContractCodes = `GET-CONTRACT-CODES-${actionTypeIdentifier}`;
export const getAPVendors = `GET-AP-VENDORS-${actionTypeIdentifier}`;
export const resetExistingContractData = `RESET-EXISTING-CONTRACT-DATA-${actionTypeIdentifier}`;
export const resetExistingApVendorData = `RESET-EXISTING-AP-VENDOR-DATA-${actionTypeIdentifier}`;
export const getMasterAccountId = `GET-MASTER-ACCOUNT-ID-${actionTypeIdentifier}`;

export const billingAccountModel = {
    billingAccountId: 0
    , billingAccountNumber: null
    , vendorDetailId: 0
    , vendorName: null
    , accountTypeId: 0
    , accountTypeName: ""
    , masterAccountId: 0
    , accountStatusId: 0
    , accountStatus: ""
    , currency: null
    , financeContractId: 0
    , contractCode: null
    , serviceTypeName: null
    , invoiceFormat: null
    , invoiceReceiptDate: ""
    , accountIntervalId: 0
    , accountInterval: ""
    , accountFirstBillId: 0
    , accountFirstBill: ""
    , allocationLevelId: 0
    , allocationLevel: ""
    , apVendorId: 0
    , apVendor: ""
    , remitId: null
    , requesterName: null
    , clientName: null
    , takeOverdate: ""
    , description: null
}

export const locationModel = {
    locationID: "",
    address1: "",
    address2: "",
    locationType: "",
    locationCity: "",
    locationState: "",
    locationCountry: "",
    locationZip: "",
    demarcLocation: null
};